import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Shield, X } from 'lucide-react';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('soprel_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = (choice) => {
    setClosing(true);
    setTimeout(() => {
      localStorage.setItem('soprel_cookie_consent', choice);
      setVisible(false);
    }, 400);
  };

  if (!visible) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-[60] transition-all duration-500 ${
        closing ? 'translate-y-full opacity-0' : 'translate-y-0 opacity-100'
      }`}
      data-testid="cookie-banner"
    >
      {/* Backdrop blur strip */}
      <div className="absolute inset-0 bg-[#0a1428]/90 backdrop-blur-md" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Icon + Text */}
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div className="w-9 h-9 bg-[#0078b7]/20 rounded-sm flex items-center justify-center flex-shrink-0 mt-0.5">
              <Shield className="h-4 w-4 text-[#0078b7]" />
            </div>
            <div className="min-w-0">
              <p className="text-white text-sm font-medium mb-1">Nous respectons votre vie privée</p>
              <p className="text-slate-400 text-xs leading-relaxed">
                Ce site utilise des cookies pour améliorer votre expérience de navigation et analyser le trafic.
                En poursuivant, vous acceptez notre{' '}
                <Link to="/politique-confidentialite" className="text-[#0078b7] hover:underline">
                  politique de confidentialité
                </Link>.
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-2 flex-shrink-0 w-full sm:w-auto">
            <button
              onClick={() => handleClose('refused')}
              className="flex-1 sm:flex-initial px-4 py-2 text-xs font-medium text-slate-400 border border-white/10 hover:border-white/20 hover:text-white transition-colors rounded-sm"
              data-testid="cookie-refuse-btn"
            >
              Refuser
            </button>
            <button
              onClick={() => handleClose('accepted')}
              className="flex-1 sm:flex-initial px-5 py-2 text-xs font-medium text-white bg-[#0078b7] hover:bg-[#0078b7]/80 transition-colors rounded-sm"
              data-testid="cookie-accept-btn"
            >
              Accepter
            </button>
            <button
              onClick={() => handleClose('dismissed')}
              className="p-1.5 text-slate-500 hover:text-white transition-colors sm:hidden"
              data-testid="cookie-close-btn"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
